import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../ui';
import { IHookFormProps, ISelectOption } from '@/interfaces';
import { SelectProps } from '@radix-ui/react-select';
import { CSSProperties, ReactNode } from 'react';
import { Controller, FieldValues, Path, UseControllerProps } from 'react-hook-form';
import { TNullable } from '@/types';
import { cn } from '@/lib/utils';

type TProps<TFieldValues extends FieldValues> = IHookFormProps<TFieldValues> & SelectProps & {
  renderClassNameItem?: (option: ISelectOption) => TNullable<string>;
  contentStyle?: CSSProperties;
  options: ISelectOption[];
  placeholder?: ReactNode;
  className?: string;
  clearable?: boolean;
};

const ControlledSelect = <TFieldValues extends FieldValues>(props: TProps<TFieldValues>) => (
  <Controller
    name={props.name as Path<TFieldValues>}
    control={props.control}
    rules={props.rules as UseControllerProps<TFieldValues>['rules']}
    defaultValue={props.defaultValue || ''}
    render={
      ({ field: { name: fieldName, onChange, value } }) => (
        <Select
          {...props}
          value={value ?? ''}
          name={fieldName}
          onValueChange={
            e => {
              const val = e === '__clear__' ? '' : e;
              props.onValueChange?.(val);
              onChange(val);
            }
          }>
          <SelectTrigger className={cn(!value && 'text-muted-foreground', props.className)}>
            <SelectValue placeholder={props.placeholder} />
          </SelectTrigger>
          <SelectContent
            style={props.contentStyle}>
            <SelectGroup>
              {props.clearable && (
                <SelectItem className="cursor-pointer text-muted-foreground text-xs" value="__clear__">
                  — Effacer la sélection
                </SelectItem>
              )}
              {
                props
                  .options
                  .map(
                    l => (
                      <SelectItem
                        className={`cursor-pointer ${props.renderClassNameItem?.(l)}`}
                        disabled={l.disabled}
                        key={l.value}
                        value={l.value!}>
                        {l.title}
                      </SelectItem>
                    )
                  )
              }
            </SelectGroup>
          </SelectContent>
        </Select>
      )
    }
  />
);

export default ControlledSelect;
